export const authBaseURL = "https://auth.excelmec.org";
export const accountsBaseURL = "https://accounts.excelmec.org";
export const accountBackendUrl = "https://accounts-api.excelmec.org"
export const eventsBaseUrl="https://events-api.excelmec.org"